import React from "react";
import { withPrefix } from "gatsby";

export default function SearcherResults({
  searchWord,
  onSelect,
  scrollIntoQuestion,
  setSearchWord,
  results,
  normalizeTwoWords,
  type,
  translate,
  renderFormattedText,
}) {
  const renderResults = () => {
    return (
      <div
        className={`m-searcher-container__results ${
          results.length > 0 ? "m-searcher-container__results--found" : ""
        }`}
      >
        <ul>
          {searchWord.length > 2 && results && results.length === 0 && (
            <li>
              <span className="m-searcher-results__title">
                {`No encontramos resultados para "${searchWord.trim()}"`}
              </span>
            </li>
          )}
          {results &&
            results.map((result, index) => (
              <li
                key={`result${index}`}
                onClick={() => {
                  onSelect(result.mmsId);
                  setSearchWord("");
                  if (scrollIntoQuestion !== undefined) {
                    scrollIntoQuestion(result.titulo);
                  }
                }}
              >
                <a
                  href={
                    result.mmsId
                      ? withPrefix(`/libros/detalle/?book=${result.mmsId}`)
                      : withPrefix(result.slug)
                  }
                  target="_self"
                  rel="noreferrer"
                  className={`gtmResultadosPredictivo${normalizeTwoWords(
                    type === "biblioteca" ? result.titulo : result.tituloBanner
                  )}${normalizeTwoWords(
                    `${translate(result.tipoContenido)} ${
                      result.tipoContenido === "book"
                        ? `${translate(result.origenContenido)}`
                        : ""
                    }`
                  )}${normalizeTwoWords(result.categoria)}`}
                >
                  <p
                    className={`gtmResultadosPredictivo${normalizeTwoWords(
                      type === "biblioteca"
                        ? result.titulo
                        : result.tituloBanner
                    )}${normalizeTwoWords(
                      `${translate(result.tipoContenido)} ${
                        result.tipoContenido === "book"
                          ? `${translate(result.origenContenido)}`
                          : ""
                      }`
                    )}${normalizeTwoWords(result.categoria)}`}
                  >
                    <span
                      className={`m-searcher-results__title 
                                     gtmResultadosPredictivo${normalizeTwoWords(
                                       type === "biblioteca"
                                         ? result.titulo
                                         : result.tituloBanner
                                     )}${normalizeTwoWords(
                        `${translate(result.tipoContenido)} ${
                          result.tipoContenido === "book"
                            ? `${translate(result.origenContenido)}`
                            : ""
                        }`
                      )}${normalizeTwoWords(result.categoria)}`}
                    >
                      {renderFormattedText(
                        type !== "preguntas"
                          ? result.titulo
                          : result.tituloBanner,
                        searchWord
                      )}
                    </span>
                    <br />
                    <span
                      className={`m-searcher-results__subtitle
                                     gtmResultadosPredictivo${normalizeTwoWords(
                                       type === "biblioteca"
                                         ? result.titulo
                                         : result.tituloBanner
                                     )}${normalizeTwoWords(
                        `${translate(result.tipoContenido)} ${
                          result.tipoContenido === "book"
                            ? `${translate(result.origenContenido)}`
                            : ""
                        }`
                      )}${normalizeTwoWords(result.categoria)}
                               `}
                    >
                      {type !== "preguntas" &&
                        renderFormattedText(
                          `${translate(result.tipoContenido)} ${
                            result.tipoContenido === "book"
                              ? `${translate(result.origenContenido)}`
                              : ""
                          }`,
                          searchWord
                        )}
                    </span>
                  </p>
                </a>
              </li>
            ))}
        </ul>
      </div>
    );
  };

  return renderResults();
}
